// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5443":"ad7f724d","6350":"72a30a16"}[chunkId] || chunkId) + "." + {"636":"51ac3bb9e2615aa6","2741":"653c787f2490dc24","5443":"770eba45a39f0de5","6350":"d9b0f982b01b02de","7856":"89a61048111254b1","9651":"bddd959a7c85efc2"}[chunkId] + ".js";
};